module.exports = "<div style=\"padding: 0 18%;\">\n    <pec-import-container email=\"$ctrl.email\">\n\n</div>"


//////////////////
// WEBPACK FOOTER
// ./client/app/features/pec-import/pec-import.html
// module id = 372
// module chunks = 0